import { FunctionComponent, memo, SyntheticEvent } from 'react';
import { Case as CaseType } from '~types';
import dayjs from 'dayjs';
import _ from 'lodash';
import { Link } from 'react-router-dom';
import { useProfile } from '../../profile/hooks';
import { useConfig } from '~components/hooks';
import { useTranslation } from 'react-i18next';
import Currency from '~components/Currency';
import FormatDate from './FormatDate';
import { useYaMetrica } from '~frontend/provider/yametrica';
import { convertNumber } from '~ui/Price';

interface FreeCaseButtonProps {
  getCase: CaseType;
}

const FreeCaseButton: FunctionComponent<FreeCaseButtonProps> = ({
  getCase,
}) => {
  const getConfig = useConfig();
  const getProfile = useProfile();
  const yametrica = useYaMetrica();
  const { t } = useTranslation();

  const reachGoal = (
    event: SyntheticEvent<HTMLElement>,
    { reachgoal } = event?.currentTarget?.dataset ||
      (event.target as HTMLElement)?.dataset,
  ) => {
    yametrica.reachGoal(reachgoal);
  };

  const amount =
    getCase?.seo?.inputMoney - (getConfig?.getCurrency?.id === 11 ? 0.1 : 1);

  return (
    <>
      <div className="case-btns-wrap">
        <FormatDate
          getDateEnd={dayjs(getCase?.getActiveGame?.createdAt)
            .add(4, 'hours')
            .format()}
        />
        <Link
          className="btn-pay btn-case-free"
          to="/pay"
          state={{
            amount,
          }}
          onClick={reachGoal}
          data-reachgoal="FundsFreeCase"
        >
          <div className="top"></div>
          <div className="top-2"></div>
          <div className="bot"></div>
          <div className="bot-2"></div>
          <div className="shadow"></div>
          <div className="shadow-2"></div>
          <div className="text">
            {t('Get for')} {amount} <Currency />
          </div>
        </Link>
        <div className="case-free-count">
          <div className="case-free-count-text">
            <div className="num">{getCase?.countOpen}</div>
            <div className="text">{t('free_buy_stats')}</div>
          </div>
          <div className="descr">{t('free_last_day')}</div>
        </div>
      </div>
      <div className="case-free-descr">
        <div className="text">{t('free_get_it')}</div>
        <div className="text-yellow">
          {t('free_sum_profit')}{' '}
          {_.round(
            ((getCase?.seo?.inputMoney - convertNumber(getProfile.inputMoney)) /
              ((getCase?.seo?.inputMoney +
                convertNumber(getProfile.inputMoney)) /
                2)) *
              100 +
              100,
            2,
          )}
          %!
        </div>
      </div>
    </>
  );
};

export default memo(FreeCaseButton);
